import React from 'react'
import { Button } from 'antd'
import styles from '../PlanManagementV3.module.scss'

// Idle state of CSV vs Live. A run in progress shows CompareRunProgress instead.
export default function EmptyCompareState({
  onUpload,
}: {
  onUpload: () => void
}) {
  return (
    <div className={styles.emptyStateCompact}>
      <h2 className={styles.emptyStateCompactTitle}>Start comparing data</h2>
      <p className={styles.emptyStateCompactDescription}>
        Upload a file to see what&apos;s new or changed
      </p>
      <Button
        type="primary"
        className={`${styles.uploadAnalyzeButton} ${styles.emptyStateCompactButton}`}
        onClick={onUpload}
      >
        Upload analyze file
      </Button>
    </div>
  )
}
